import { Avatar, Space } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';

interface IOrderedListItemProps {
  orderIndex: number;
  title?: string;

  subtitle?: string;
}

export const OrderedListItem = ({ title, subtitle, orderIndex }: IOrderedListItemProps) => (
  <Space
    align="center"
    size={12}
    // eslint-disable-next-line react/no-array-index-key
    key={orderIndex}
  >
    <Avatar size={36}>{orderIndex}</Avatar>
    <Space
      direction="vertical"
      size={4}
    >
      {title && (
        <Text
          strong
          size={16}
        >
          {title}
        </Text>
      )}
      {subtitle && <Text className="h-color-D60">{subtitle}</Text>}
    </Space>
  </Space>
);
